import dynamic from "next/dynamic";

export const DynamicPostiesFooter = dynamic<Record<string, never>>(() =>
  import("~/components/posties/footer").then(module => module.PostiesFooter),
);

export const DynamicStyleFooter = dynamic<Record<string, never>>(() =>
  import("~/components/section/section-style/footer").then(module => module.StyleFooter),
);
